import { Carousel } from 'antd';
import React, { useRef, useState, createElement } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './index.less';
const DataVCarousel = (props) => {
    const { title, tabs, carouselConfig, tabsConfig, showArrow, className } = props;
    const carouselRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const onPrev = () => {
        carouselRef.current.prev();
    };
    const onNext = () => {
        carouselRef.current.next();
    };
    const beforeChange = (from, to) => {
        setCurrentIndex(to);
        props?.carouselConfig?.beforeChange?.(from, to);
    };
    const renderTabsTitle = () => {
        if (!tabsConfig?.showTitle) {
            return null;
        }
        return (createElement("div", { className: className ? `dv-data-v-carousel-tabs ${className}` : 'dv-data-v-carousel-tabs' }, tabs?.map((tab, index) => {
            return (createElement("span", { key: index, className: `dv-data-v-carousel-tabs-title ${index === currentIndex ? 'active' : ''}`, onClick: () => {
                    carouselRef.current.goTo(index);
                } }, tab.title));
        })));
    };
    return (createElement("div", { className: "dv-data-v-carousel" },
        createElement("div", { className: "dv-data-v-carousel-title" },
            createElement("div", null, title),
            renderTabsTitle()),
        showArrow ? (createElement(React.Fragment, null,
            createElement("p", { className: "dv-data-v-carousel-prev", onClick: onPrev },
                createElement(LeftOutlined, null)),
            createElement("p", { className: "dv-data-v-carousel-next", onClick: onNext },
                createElement(RightOutlined, null)))) : null,
        createElement(Carousel, { ...carouselConfig, dots: false, ref: carouselRef, beforeChange: beforeChange }, tabs?.map((tab, index) => {
            return createElement(React.Fragment, { key: index }, tab.content);
        }))));
};
export default DataVCarousel;
